import {
  ApartmentOutlined,
  AppstoreOutlined,
  FileDoneOutlined,
  CalculatorOutlined,
  EditOutlined,
  ContainerOutlined,
  ClockCircleOutlined,
  AlertOutlined,
  RiseOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const workflowsSidebar: SidebarConfig = {
  module: 'workflows',
  titleKey: 'common:nav.workflows',
  icon: <ApartmentOutlined />,
  sections: [
    {
      key: 'overview',
      labelKey: 'workflows:sidebar.sections.overview',
      items: [
        { key: 'catalog', path: '/workflows', labelKey: 'workflows:sidebar.items.catalog', icon: <AppstoreOutlined /> },
      ],
    },
    {
      key: 'sprint2',
      labelKey: 'workflows:sidebar.sections.sprint2',
      items: [
        { key: 'contract-billing', path: '/workflows/contract-billing', labelKey: 'workflows:contractBilling.title', icon: <FileDoneOutlined /> },
        { key: 'estimate-cost', path: '/workflows/estimate-cost', labelKey: 'workflows:estimateToCost.title', icon: <CalculatorOutlined /> },
        { key: 'vo-lifecycle', path: '/workflows/vo-lifecycle', labelKey: 'workflows:voLifecycle.title', icon: <EditOutlined /> },
        { key: 'material-request', path: '/workflows/material-request', labelKey: 'workflows:materialRequest.title', icon: <ContainerOutlined /> },
      ],
    },
    {
      key: 'sprint3',
      labelKey: 'workflows:sidebar.sections.sprint3',
      items: [
        { key: 'attendance-payroll', path: '/workflows/attendance-payroll', labelKey: 'workflows:attendancePayroll.title', icon: <ClockCircleOutlined /> },
        { key: 'claim-lifecycle', path: '/workflows/claim-lifecycle', labelKey: 'workflows:claimLifecycle.title', icon: <AlertOutlined /> },
        { key: 'progress-dashboard', path: '/workflows/progress-dashboard', labelKey: 'workflows:progressDashboard.title', icon: <RiseOutlined /> },
        { key: 'lead-to-award', path: '/workflows/lead-to-award', labelKey: 'workflows:leadToAward.title', icon: <TrophyOutlined /> },
      ],
    },
  ],
};
